<template>
  <section class="aboutus-page-container">
    <b-container class="my-4">
      <b-row>
        <b-col md="12">
          <div class="header">
            <h4 class="text-brand">من نحن ؟</h4>
          </div>
        </b-col>
        <b-col md="12">
          <div class="content ">
            <b-row class="align-items-center">
              <b-col md="8">
                <div style="display: flex;justify-content: center;">
                  <p>
                    {{ data.about_us }}
                  </p>
                </div>
              </b-col>
              <b-col md="4">
                <div style="display: flex;justify-content: center;">
                  <img src="../assets/images/aboutus/aboutus1_img.png" width="300" height="250" class="aboutus-img" alt="من نحن ؟"/>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <div class="header">
            <h4 class="text-brand">رسالتنا</h4>
          </div>
        </b-col>
        <b-col md="12">
          <div class="content ">
            <b-row class="align-items-center">
              <b-col md="4">
                <div style="display: flex;justify-content: center;">
                  <img src="../assets/images/aboutus/aboutus2_img.png" width="300" height="250" class="aboutus-img" alt="رسالتنا"/>
                </div>
              </b-col>
              <b-col md="8">
                <div style="display: flex;justify-content: center;">
                  <p>
                    {{ data.our_mission }}
                  </p>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <div class="header">
            <h4 class="text-brand">رؤيتنا</h4>
          </div>
        </b-col>
        <b-col md="12">
          <div class="content ">
            <b-row class="align-items-center">
              <b-col md="8">
                <div style="display: flex;justify-content: center;">
                  <p>
                    {{ data.our_vision }}
                  </p>
                </div>
              </b-col>
              <b-col md="4">
                <div style="display: flex;justify-content: center;">
                  <img src="../assets/images/aboutus/aboutus1_img.png" width="300" height="250" class="aboutus-img" alt="رؤيتنا"/>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  import store from "../store/index.js"
  import { sendRequest }  from "../utils/RequestHelper.js"

  export default {
    name: 'Home',
    data() {
      return {
        data: {},
        langDec: {}
      }
    },
    methods: {


      loadData() {
        this.pageIsLoading = true;
        var successCallback = (data) => {
          this.data = data || {}
          this.pageIsLoading = false;
        };
        var errorCallback = () => {
          this.pageIsLoading = false;
        };
        sendRequest('get', 'configuration/configuration/', false, {}, successCallback, errorCallback);
      },
    },
    created() {
      this.langDec = store.getters.getLangData
      this.loadData()
    }
  }
</script>

<style scoped>
 .aboutus-page-container{
  background-color: rgb(236, 236, 236) !important;
 }
 h4{
  margin-bottom: 0;
  font-size: 40px;
  font-weight: bold;
 }
 .aboutus-page-container .header, 
 .aboutus-page-container .content{
  background-color: white !important;
  border-radius: 30px;
  padding: 25px 30px;
  margin-bottom: 30px;
 }
.aboutus-page-container .header{
  font-weight: bold;
  margin-bottom: 15px !important;
}
.aboutus-page-container .content p{
  text-align: justify;
  font-size: 20px;
}
.aboutus-img{
  max-width: 100%;
  height: auto;
  max-height: 250px;
  object-fit: contain;
}

/* mobile */
@media (max-width: 575.98px) {
  h4{
    font-size: 28px;
  }
  .aboutus-page-container .header,
  .aboutus-page-container .content{
    border-radius: 20px;
    padding: 16px 18px;
    margin-bottom: 20px;
  }
  .aboutus-page-container .content p{
    /* justify leaves large gaps on narrow lines */
    text-align: start;
    font-size: 17px;
  }
}
</style>